import {
  StandardEditResponseModel,
  StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { ProvinceModel } from "../pages/shared/models/provinceModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getProvinces(
  filter: any,
  limit?: number,
  page?: number,
): Promise<StandardResponseModel<ProvinceModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/provinces`,
        { filter },
        { params, ...authorizationHeader },
      )
      .then((response) => {
        return response?.data as StandardResponseModel<ProvinceModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getProvinceById(provinceId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/provinces/${provinceId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function createProvince(
  data: ProvinceModel,
): Promise<StandardResponseModel<ProvinceModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .post(
        `${API_URL}/provinces/create`,
        {
          ...data,
          country: data.country ? data.country.countryId : undefined,
        },
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as StandardResponseModel<ProvinceModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function editProvince(provinceId: number, updateData: ProvinceModel) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/provinces/${provinceId}`,
        {
          ...updateData,
          country: updateData.country
            ? updateData.country.countryId
            : undefined,
          provinceId: undefined,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as StandardEditResponseModel);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function deleteProvinceById(provinceId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/provinces/${provinceId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getProvinces,
  getProvinceById,
  createProvince,
  editProvince,
  deleteProvinceById,
};
